import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import usePermissionHook from 'hooks/usePermissionHook';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

const GSTFailed = () => {
    const router = useRouter();
    const { getLobFromPermission, getPartnerIdFromPermission } =
        usePermissionHook();
    const onClick = () => {
        router.push(
            `/${getLobFromPermission()}/${getPartnerIdFromPermission()}/dashboard`
        );
    };
    return (
        <Styles.Container>
            <Styles.BoldText>
                <Image
                    src={getImageBasePath('/icons/error.svg')}
                    width={40}
                    height={40}
                    style={{
                        marginTop: '4px',
                    }}
                />
                GST Validation Failed
            </Styles.BoldText>
            <Styles.Banner>
                <Image
                    width={'250px'}
                    height={'250px'}
                    alt={''}
                    src={getImageBasePath('/images/payment_failure.svg')}
                />
            </Styles.Banner>
            <Styles.Text>
                We couldn&apos;t verify your GST number because of a validation
                issue. Please double-check and try again.<br></br>
                <br></br>
            </Styles.Text>
            <Styles.Text>
                If the issue continues, contact us at mpos@acko.com and
                we&apos;ll help you resolve it promptly.
            </Styles.Text>
            <Styles.ButtonContainer>
                <PrimaryButton onClick={onClick}>Retry</PrimaryButton>
            </Styles.ButtonContainer>
        </Styles.Container>
    );
};

export default GSTFailed;
